/* eslint-disable */
import { useRecoilState } from 'recoil'
import { popupState } from '../atoms'
export default function Popup(props){
  let [popup, setPopup] = useRecoilState(popupState)
  return(
  <div className="popupWrap">
    <div className="popupBack" onClick={() => {setPopup(false)}}></div>
    <div className="popupBox">
      <button className="popupXbtn" onClick={() => {setPopup(false)}}>
        <div></div>
        <div></div>
      </button>
      <div className="popupTitle">{props.title}</div>
      <div className="popupContent" dangerouslySetInnerHTML={{__html : props.txt}}></div>
    </div>
  </div>
  )
}